var _rect, _g, _image, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentPrintableSpanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175 179",
    enableBackground: "new 0 0 175 179",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    strokeMiterlimit: 10,
    width: 175,
    height: 179,
    id: "rect3337",
    stroke: "#D1D1D1",
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3339"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M31.9,20.3l0.7-1.1c0.2,0.2,0.9,0.8,2.1,0.8c1,0,1.7-0.6,1.7-1.3c0-1-1-1.3-2.1-1.8   c-1.1-0.6-2.1-1.2-2.1-2.7c0-1.6,1.3-2.5,2.9-2.5c1.5,0,2.3,0.5,2.6,0.8L37,13.5c-0.3-0.2-1-0.6-1.9-0.6c-0.8,0-1.4,0.4-1.4,1.2   c0,0.8,0.7,1.1,1.7,1.6c1.2,0.6,2.5,1.2,2.5,3c0,1.6-1.3,2.7-3.2,2.7C33.2,21.3,32.3,20.7,31.9,20.3z",
    id: "path3341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M39.6,19.3v-3.8h-1.1v-1.1h1.1v-1.9h1.5v1.9h1.6v1.1h-1.6v3.6c0,0.7,0.2,1,0.7,1c0.4,0,0.8-0.2,0.9-0.3   l0.4,1.1c-0.3,0.1-0.8,0.4-1.6,0.4C40.2,21.3,39.6,20.5,39.6,19.3z",
    id: "path3343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M44.3,19.1v-4.8h1.5v4.5c0,0.8,0.3,1.2,1,1.2c0.9,0,1.5-0.8,1.6-1v-4.7H50v5.1c0,0.7,0.1,1.4,0.2,1.7h-1.5   c0-0.2-0.1-0.6-0.1-1c-0.3,0.4-1,1.1-2.2,1.1C44.9,21.3,44.3,20.3,44.3,19.1z",
    id: "path3345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M51.5,17.7c0-2.2,1.3-3.6,3-3.6c0.7,0,1.3,0.2,1.6,0.5V11h1.5v8.4c0,0.7,0.1,1.3,0.2,1.7h-1.5   c-0.1-0.2-0.1-0.5-0.1-0.8c-0.5,0.6-1.1,0.9-1.9,0.9C52.6,21.3,51.5,20,51.5,17.7z M56.1,19.2v-3.4c-0.4-0.3-0.8-0.5-1.4-0.5   c-1.1,0-1.7,0.9-1.7,2.4c0,1.4,0.5,2.3,1.6,2.3C55.3,20,55.8,19.7,56.1,19.2z",
    id: "path3347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M59.1,17.7c0-2.1,1.4-3.5,3.2-3.5c1.8,0,2.8,1.2,2.8,3.2c0,0.2,0,0.4,0,0.6h-4.4c0.1,1.2,0.6,2.2,1.9,2.2   c0.9,0,1.5-0.4,1.8-0.5l0.5,1c-0.4,0.2-1.1,0.7-2.4,0.7C60.3,21.3,59.1,19.8,59.1,17.7z M63.6,16.9c0-0.9-0.4-1.6-1.4-1.6   c-0.9,0-1.4,0.6-1.6,1.6H63.6z",
    id: "path3349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M66.7,14.3h1.5v0.9c0.5-0.7,1.3-1.1,2.2-1.1c1.5,0,2,1,2,2.2v4.8h-1.5v-4.5c0-0.8-0.3-1.2-1-1.2   c-0.7,0-1.3,0.5-1.6,1v4.7h-1.5V14.3z",
    id: "path3351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M74.7,19.3v-3.8h-1.1v-1.1h1.1v-1.9h1.5v1.9h1.6v1.1h-1.6v3.6c0,0.7,0.2,1,0.7,1c0.4,0,0.8-0.2,0.9-0.3   l0.4,1.1c-0.3,0.1-0.8,0.4-1.6,0.4C75.3,21.3,74.7,20.5,74.7,19.3z",
    id: "path3353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M82.1,16.5h3v1.2h-3V16.5z",
    id: "path3355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M90,11.8h2.7c2,0,3.4,0.9,3.4,2.8c0,1.9-1.4,3-3.6,3h-1v3.5H90V11.8z M92.6,16.3c1.4,0,2-0.6,2-1.7   c0-1-0.6-1.6-2-1.6h-1v3.3H92.6z",
    id: "path3357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M97.7,14.3h1.5v1c0.3-0.5,0.9-1.1,1.8-1.1c0.5,0,0.7,0.1,0.8,0.2l-0.4,1.3c-0.1-0.1-0.3-0.1-0.7-0.1   c-0.9,0-1.4,0.9-1.6,1.2v4.4h-1.5V14.3z",
    id: "path3359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M102.8,12.3c0-0.5,0.4-1,1-1c0.6,0,1,0.4,1,1c0,0.5-0.4,1-1,1C103.2,13.3,102.8,12.8,102.8,12.3z M103,14.3   h1.5v6.8H103V14.3z",
    id: "path3361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M106.6,14.3h1.5v0.9c0.5-0.7,1.3-1.1,2.2-1.1c1.5,0,2,1,2,2.2v4.8h-1.5v-4.5c0-0.8-0.3-1.2-1-1.2   c-0.7,0-1.3,0.5-1.6,1v4.7h-1.5V14.3z",
    id: "path3363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M114.7,19.3v-3.8h-1.1v-1.1h1.1v-1.9h1.5v1.9h1.6v1.1h-1.6v3.6c0,0.7,0.2,1,0.7,1c0.4,0,0.8-0.2,0.9-0.3   l0.4,1.1c-0.3,0.1-0.8,0.4-1.6,0.4C115.2,21.3,114.7,20.5,114.7,19.3z",
    id: "path3365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M119,19.4c0-1.8,1.9-2.4,3.6-2.4h0.3v-0.5c0-0.8-0.4-1.2-1.2-1.2c-0.7,0-1.2,0.3-1.7,0.7l-0.7-1   c0.6-0.5,1.5-1,2.6-1c1.7,0,2.5,0.7,2.5,2.4v2.8c0,0.8,0.1,1.4,0.2,1.8h-1.5c0-0.2-0.1-0.6-0.1-0.8c-0.4,0.5-1.1,0.9-2,0.9   C119.9,21.3,119,20.6,119,19.4z M122.9,19.4V18h-0.3c-1.2,0-2.1,0.4-2.1,1.3c0,0.6,0.5,0.8,0.9,0.8   C122.1,20.1,122.6,19.8,122.9,19.4z",
    id: "path3367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M126.3,20.7V11h1.5v3.8c0.4-0.4,1-0.7,1.7-0.7c1.8,0,2.9,1.3,2.9,3.5c0,2.2-1.5,3.6-3.5,3.6   C127.7,21.3,126.8,21,126.3,20.7z M130.8,17.7c0-1.3-0.5-2.3-1.7-2.3c-0.5,0-1.1,0.3-1.3,0.6v3.9c0.2,0.1,0.6,0.2,1.1,0.2   C130.1,20.1,130.8,19.1,130.8,17.7z",
    id: "path3369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M134,11h1.5v10.1H134V11z",
    id: "path3371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M137,17.7c0-2.1,1.4-3.5,3.2-3.5c1.8,0,2.8,1.2,2.8,3.2c0,0.2,0,0.4,0,0.6h-4.4c0.1,1.2,0.6,2.2,1.9,2.2   c0.9,0,1.5-0.4,1.8-0.5l0.5,1c-0.4,0.2-1.1,0.7-2.4,0.7C138.2,21.3,137,19.8,137,17.7z M141.6,16.9c0-0.9-0.4-1.6-1.4-1.6   c-0.9,0-1.4,0.6-1.6,1.6H141.6z",
    id: "path3373"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 96,
    height: 125,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAB9CAYAAABd0GZ9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ bWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6 eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1 NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEu MC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVz b3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1N Ok9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowYmU1OWNhZC0wNWE0LTQ0OWUtOTE5NS00OTdl M2JhMzI2NGQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTg0RjRFODQ3ODNGMTFFNDg2RDND MDYwNjQ1RjI2NzQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTg0RjRFODM3ODNGMTFFNDg2 RDNDMDYwNjQ1RjI2NzQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNp bnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NGY1 N2MxYTktYTE1Zi00NTUyLWE5ZjQtOWNiYmQ2MGNkZjYwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAu ZGlkOjBiZTU5Y2FkLTA1YTQtNDQ5ZS05MTk1LTQ5N2UzYmEzMjY0ZCIvPiA8L3JkZjpEZXNjcmlw dGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmyO5bsAAAGm SURBVHja7N27bQJBFIVhBrkZUhL6cEwNVGAiOqAERIyFXIUTKrJ4ZZuxXs2Lme+PHCzJ/HvuPayR NpzOP7cZijF3BGX5GPwdHEdWbhJgBIEAAggAAQSggu8Bo7srRhEkwAgCAQSAAAJAAAEggAAQUBn/ fRbk/8YSQAAIIAAEEAACCEDmL2J48Hm8jLrutF4SkJBXvxAJKRJQy89SmnkkYgcQYAl3Gf0UC1UL KrxQjSA7AKlHkBoqAUYQ1ND66qQaWrhOGkF2ANRQCQABGfhaXKNc01QNrVGCBGS+mwnQgt6zBaW8 wyVAC2pvlu9W+yjXNNeCphzw86C2v5uX13z/HSYdsBHU2BJuklh3c9cJiDmX1dCJu6jGA7YDCEA3 NVQCQAAB6LeGSgCSJ6B2QsbPRUlhGLxFScXMi3fI2AEgQA1tF+8PMIIQfQSpqhJAAAhQQ6GGGkFQ QyUABBAANVQNhRGkhkICCIAWpAXBCNKCIAEEgAA1VA2VACMIaqgEgAACoIaqoSBADYUEEAACCAAB BBDgCAggAAQQgDIMnwV51CwB/XEXYAD0F0HTR7KGzwAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 39.4998 41.5618)",
    id: "image3375"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g3377"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g3379"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g3381"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g3383"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g3385"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g3387"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g3389"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g3391"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g3393"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g3395"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g3397"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g3399"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g3401"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g3403"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g3405"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "11.25px",
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    x: 22.13781,
    y: 39.426384,
    id: "text3413"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3415",
    x: 22.13781,
    y: 39.426384
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "11.25px",
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    x: 26.143698,
    y: 37.950531,
    id: "text3417"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3419",
    x: 26.143698,
    y: 37.950531,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "12.5px",
      fontFamily: "Calibri",
      InkscapeFontSpecification: "Calibri"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "m 64.660778,34.429623 0.7,-1.1 c 0.2,0.2 0.9,0.8 2.1,0.8 1,0 1.7,-0.6 1.7,-1.3 0,-1 -1,-1.3 -2.1,-1.8 -1.1,-0.6 -2.1,-1.2 -2.1,-2.7 0,-1.6 1.3,-2.5 2.9,-2.5 1.5,0 2.3,0.5 2.6,0.8 l -0.7,1 c -0.3,-0.2 -1,-0.6 -1.9,-0.6 -0.8,0 -1.4,0.4 -1.4,1.2 0,0.8 0.7,1.1 1.7,1.6 1.2,0.6 2.5,1.2 2.5,3 0,1.6 -1.3,2.7 -3.2,2.7 -1.5,-0.1 -2.4,-0.7 -2.8,-1.1 z",
    id: "path3341-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "m 71.940049,28.620493 1.5,0 0,0.7 c 0.4,-0.4 1,-0.9 1.9,-0.9 1.7,0 2.8,1.3 2.8,3.5 0,2.1 -1.3,3.6 -3,3.6 -0.9,0 -1.4,-0.3 -1.6,-0.5 l 0,3.4 -1.5,0 0,-9.8 z m 4.6,3.4 c 0,-1.4 -0.5,-2.3 -1.6,-2.3 -0.8,0 -1.3,0.6 -1.5,0.8 l 0,3.3 c 0.3,0.2 0.7,0.5 1.4,0.5 1.1,0.1 1.7,-0.9 1.7,-2.3 z",
    id: "path3459"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "m 79.197647,33.777688 c 0,-1.8 1.9,-2.4 3.6,-2.4 l 0.3,0 0,-0.5 c 0,-0.8 -0.4,-1.2 -1.2,-1.2 -0.7,0 -1.2,0.3 -1.7,0.7 l -0.7,-1 c 0.6,-0.5 1.5,-1 2.6,-1 1.7,0 2.5,0.7 2.5,2.4 l 0,2.8 c 0,0.8 0.1,1.4 0.2,1.8 l -1.5,0 c 0,-0.2 -0.1,-0.6 -0.1,-0.8 -0.4,0.5 -1.1,0.9 -2,0.9 -1.1,0.2 -2,-0.5 -2,-1.7 z m 3.9,0 0,-1.4 -0.3,0 c -1.2,0 -2.1,0.4 -2.1,1.3 0,0.6 0.5,0.8 0.9,0.8 0.7,0 1.2,-0.3 1.5,-0.7 z",
    id: "path3367-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "m 86.10524,28.644641 1.5,0 0,0.9 c 0.5,-0.7 1.3,-1.1 2.2,-1.1 1.5,0 2,1 2,2.2 l 0,4.8 -1.5,0 0,-4.5 c 0,-0.8 -0.3,-1.2 -1,-1.2 -0.7,0 -1.3,0.5 -1.6,1 l 0,4.7 -1.5,0 0,-6.8 z",
    id: "path3351-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "m 93.647816,26.779622 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 0,0.5 -0.4,1 -1,1 -0.6,0 -1,-0.5 -1,-1 z m 0.2,2 1.5,0 0,6.8 -1.5,0 0,-6.8 z",
    id: "path3361-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "m 96.675383,34.917724 0.5,-1.1 c 0.3,0.2 0.9,0.6 1.7,0.6 0.8,0 1.199997,-0.3 1.199997,-0.8 0,-0.5 -0.599997,-0.7 -1.599997,-1.2 -1,-0.4 -1.7,-1 -1.7,-2 0,-1.2 0.9,-2 2.4,-2 1.099997,0 1.799997,0.4 2.099997,0.6 l -0.6,1 c -0.3,-0.2 -0.799996,-0.5 -1.499997,-0.5 -0.7,0 -1,0.3 -1,0.7 0,0.5 0.6,0.7 1.3,1 1.099997,0.4 1.999997,0.9 1.999997,2.1 0,1.3 -1,2.1 -2.599997,2.1 -1,0.2 -1.8,-0.2 -2.2,-0.5 z",
    id: "path3620"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "m 102.7613,25.418786 1.5,0 0,4.2 c 0.3,-0.4 1,-1.1 2.2,-1.1 1.5,0 2,1 2,2.2 l 0,4.8 -1.5,0 0,-4.5 c 0,-0.8 -0.3,-1.2 -1,-1.2 -0.9,0 -1.5,0.8 -1.7,1 l 0,4.7 -1.5,0 0,-10.1 z",
    id: "path3610"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentPrintableSpanish);
export default __webpack_public_path__ + "static/media/studentPrintableSpanish.9ea7f9c9ca3728914b499f1bb58b2cd8.svg";
export { ForwardRef as ReactComponent };